import { Token } from "modules/auth/types";

export const getToken = () => localStorage.getItem("accessToken");

export const getRefreshToken = () => localStorage.getItem("refreshToken") ?? "";

export const getExpiresAt = () =>
  parseInt(localStorage.getItem("expiresAt") ?? "");

export const storeTokens = (json: Token) => {
  const expiresAt = new Date(Date.now() + json.expiresIn * 1000).getTime();

  localStorage.setItem("accessToken", json.accessToken);
  localStorage.setItem("refreshToken", json.refreshToken);
  localStorage.setItem("expiresAt", `${expiresAt}`);
};

export const removeTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("expiresAt");
};

export const hasTokenExpired = () => {
  let expired = Date.now() > getExpiresAt();
  if (getExpiresAt()) {
    return expired;
  }
  return true;
};
